export enum SCHOOL_NAMES {
	SNL = 'snl',
}